const state = {
  homeBar: [
    {
      id: "6",
      name: "电动车入楼",
      type: "diandongche",
      num: 0,
      img: require("@/assets/img/top8.png"),
      path: "/ddcjl",
    },
    {
      id: "17",
      name: "电动车管控",
      type: "rfid",
      num: 0,
      img: require("@/assets/img/top11.png"),
      path: "/rfidDangers",
    },
    {
      id: "15",
      name: "电瓶进楼",
      type: "dianchi",
      num: 0,
      img: require("@/assets/img/top11.png"),
      path: "/monitorDcDangers",
    },
    {
      id: "9",
      name: "疏散通道",
      type: "duiwuduiliao",
      num: 0,
      img: require("@/assets/img/top9.png"),
      path: "/lddw",
    },
    {
      id: "33",
      name: "垃圾分类",
      type: "ljsb",
      num: 0,
      img: require("@/assets/img/ljt.png"),
      path: "/ljsb",
    },
    {
      id: "7",
      name: "消防车道",
      type: "xiaofangtongdao",
      num: 0,
      img: require("@/assets/img/top13.png"),
      path: "/fireEngine",
    },
    {
      id: "10",
      name: "防火门",
      type: "fanghuomen",
      num: 0,
      img: require("@/assets/img/top10.png"),
      path: "/securityDoor",
    },
    {
      id: "16",
      name: "电梯",
      type: "dianti",
      num: 0,
      img: require("@/assets/img/street/lly-dianti1.png"),
      path: "/elevatorDangers",
    },
    {
      id: "2",
      name: "烟感",
      type: "yangan",
      num: 0,
      img: require("@/assets/img/icon-ygcj.png"),
      path: "/listSmokeDangers",
    },
    {
      id: "5",
      name: "手报",
      type: "shoubao",
      num: 0,
      img: require("@/assets/img/icon-shoubao.png"),
      path: "/handNewspaperDangers",
    },
    {
      id: "3",
      name: "微信",
      type: "weixin",
      num: 0,
      img: require("@/assets/img/icon-weixin.png"),
      path: "/weChatDangers",
    },
    {
      id: "0",
      name: "119",
      type: "119",
      num: 0,
      img: require("@/assets/img/top6.png"),
      path: "/callOneOneNineDangers",
    },
    {
      id: "4",
      name: "举报",
      type: "yinhuanjubao",
      num: 0,
      img: require("@/assets/img/top12.png"),
      path: "/hiddenDangers",
    },
    {
      id: "11",
      name: "防火巡查",
      type: "fanghuojiancha",
      num: 0,
      img: require("@/assets/img/icon-ladong.png"),
      path: "/fireWatch",
    },
    {
      id: "1",
      name: "拉动",
      type: "xiaofangladong",
      num: 0,
      img: require("@/assets/img/street/index-icon-yhcz.png"),
      path: "/pullDrillDangers",
    },
    {
      id: "13",
      name: "后厨",
      type: "chufang",
      num: 0,
      img: require("@/assets/img/top11.png"),
      path: "/kitchenDangers",
    },
    {
      id: "14",
      name: "中控",
      type: "zhongkongshi",
      num: 0,
      img: require("@/assets/img/top1.png"),
      path: "/unifyDangers",
    },
    {
      id: "12",
      name: "消火栓",
      type: "xiaofangshuiya",
      num: 0,
      img: require("@/assets/img/water.png"),
      path: "/waterDangers",
    },
    {
      id: "8",
      name: "火眼",
      type: "huoyan",
      num: 0,
      img: require("@/assets/img/top4.png"),
      path: "/pinkeyeDangers",
    },
    {
      id: "18",
      name: "光感",
      type: "guanghuoyan",
      num: 0,
      img: require("@/assets/img/guanggan.png"),
      path: "/Pyrotechnicseye",
    },
    {
      id: "19",
      name: "语音呼叫",
      type: "yyhj",
      num: 0,
      img: require("@/assets/img/yuyinhujiao.png"),
      path: "/voiceAlarmList",
    },
    {
      id: "20",
      name: "一键呼",
      type: "sphj",
      num: 0,
      img: require("@/assets/img/shipinhujiao.png"),
      path: "/videoAlarm",
    },
    {
      id: "21",
      name: "电动车违规",
      type: "ddcwgyj",
      num: 0,
      img: require("@/assets/img/street/index-icon-carDdc.png"),
      path: "/carHomeAlarm",
    },
    {
      id: "22",
      name: "视频巡控",
      type: "spxk",
      num: 0,
      img: require("@/assets/img/top1.png"),
      path: "/videoPatrol",
    },
    {
      id: "23",
      name: "通道监管",
      type: "tdjg",
      num: 0,
      img: require("@/assets/img/top13.png"),
      path: "/channelSupervision",
    },
    {
      id: "25",
      name: "呼叫火眼",
      type: "hujioahuoyan",
      num: 0,
      img: require("@/assets/img/top25.png"),
      path: "/hjhyIndex",
    },
    {
      id: "26",
      name: "电气监测",
      type: "dianqiyinhuan",
      num: 0,
      img: require("@/assets/img/top26.png"),
      path: "/dqyhIndex",
    },
    {
      id: "27",
      name: "温感",
      type: "wengan",
      num: 0,
      img: require("@/assets/img/top27.png"),
      path: "/wgIndex",
    },
    // {
    //   id: "34",
    //   name: "入户充电",
    //   type: "homecharging",
    //   num: 0,
    //   img: require("@/assets/img/top34.png"),
    //   path: "/homeChargingIndex",
    // },
    {
      id: "35",
      name: "充电监测",
      type: "chongdianhe",
      num: 0,
      img: require("@/assets/img/top35.png"),
      path: "/cdh",
    },
    {
      id: "36",
      name: "积水监测",
      type: "waterlogging",
      num: 0,
      img: require("@/assets/img/top36.png"),
      path: "/waterlogging",
    },
    {
      id: "37",
      name: "车棚灭火",
      type: "ddcp",
      num: 0,
      img: require("@/assets/img/top37.png"),
      path: "/ddcp",
    },
    {
      id: "38",
      name: "灭火器",
      type: "mhq",
      num: 0,
      img: require("@/assets/img/top37.png"),
      path: "/mhq",
    },
    {
      id: "39",
      name: "动火离人",
      type: "dhlr",
      num: 0,
      img: require("@/assets/img/top39.png"),
      path: "/dhlr",
    },
    {
      id: "41",
      name: "消防水源",
      type: "xiaofangshuiyuan",
      num: 0,
      img: require("@/assets/img/water.png"),
      path: "/water",
    },
    {
      id: "43",
      name: "消防巡查",
      type: "xiaofangxuncha",
      num: 0,
      img: require("@/assets/img/icon-ladong.png"),
      path: "/xfxc",
    },
    {
      id: "46",
      name: "人员巡查",
      type: "ryxc",
      num: 0,
      img: require("@/assets/img/icon-ladong.png"),
      path: "/ry-inspect-nav",
    },
    {
      id: "47",
      name: "问题分析",
      type: "flfx",
      num: 0,
      img: require("@/assets/img/icon-ladong.png"),
      path: "/flfx",
    },
    {
      id: "48",
      name: "决策分析",
      type: "jcfx",
      num: 0,
      img: require("@/assets/img/icon-ladong.png"),
      path: "/jcfx",
    },
    {
      id: "45",
      name: "重点人",
      type: "zdr",
      num: 0,
      img: require("@/assets/img/icon-ladong.png"),
      path: "/people",
    },
  ],
  homeBarList: [],
  hzbjNum: 0,
  // 导航分类：一类、二类、三类
  // [\"33\", \"48\", \"47\", \"46\"]
  homeBarCategory: {
    one: [2, 5, 20, 37, 8, 9, 7, 6, 10, 12, 38, 45, 43, 33, 46],
    two: [5, 47, 48],
    three: [35, 26, 41, 36, 22],
  },
};

const mutations = {
  SET_NUM(state, { type, num }) {
    const item = state.homeBar.find((item) => item.type === type);
    if (item) {
      item.num = num;
    }
  },
  INCREMENT_HZBJ_INIT(state) {
    state.hzbjNum = 0;
  },
  INCREMENT_HZBJ_NUM(state, num) {
    state.hzbjNum += num;
  },
  SET_MENU_LIST(state, menuList) {
    // id 999 代表 烟感报警
    const idArrayInOrder = [6, 17, 15, 9, 10, 7, 12, 26, 34, 35, 20, 8, 18, 45, 999, 27, 5, 46, 22, 38, 39, 11, 33, 36, 16, 1, 13, 14, 19, 21, 23, 25, 3, 0, 4, 47, 48];
    state.homeBarList = menuList.sort((a, b) => {
      const indexA = idArrayInOrder.findIndex(id => id === Number(a.id));
      const indexB = idArrayInOrder.findIndex(id => id === Number(b.id));
      return indexA - indexB;
    });
  }
};

const actions = {
  // todo 移除
  updateMsgNumber({ commit, state, rootState }, deptIds = '') {
    return new Promise((resolve, reject) => {
      this._vm.http.get("webapi/main/queryMissedCallCount", { deptIds: deptIds }, (response => {
        const e = response;
        commit('INCREMENT_HZBJ_INIT');
        state.homeBar.forEach((element) => {
          Object.keys(e).forEach((key) => {
            if (element.type === key) {
              if (e[key] > 0 && ["yangan", "shoubao", "guanghuoyan", "wengan"].includes(key)) {
                commit('INCREMENT_HZBJ_NUM', Number(e[key]));
              } else {
                commit('SET_NUM', { type: key, num: e[key] });
              }
            }
          });
        });
        commit('SET_MENU_LIST', setMenuList(state, rootState));
        resolve();
      }))
    });
  }
};

const getters = {
  homeBar: (state) => state.homeBar,
  homeBarList: (state) => state.homeBarList,
  hzbjNum: (state) => state.hzbjNum,
  // 按三类分组的导航列表（扁平，带 category 字段，兼容历史）
  homeBarCategoryFlatList: (state) => {
    const list = state.homeBarList.length ? state.homeBarList : state.homeBar;
    const categoryOrder = ["one", "two", "three"];
    const result = [];
    const seen = new Set();
    categoryOrder.forEach((cat) => {
      state.homeBarCategory[cat].forEach((id) => {
        const found = findItemInList(list, id);
        if (found && !seen.has(found.id)) {
          seen.add(found.id);
          result.push({ ...found, category: cat });
        }
      });
    });
    return result;
  },
  // 按三类分组的导航列表（分组结构：[{ category, items }, ...]）
  homeBarCategoryGroups: (state) => {
    const list = state.homeBarList.length ? state.homeBarList : state.homeBar;
    const categoryOrder = ["one", "two", "three"];
    const result = [];
    const seen = new Set();
    categoryOrder.forEach((cat) => {
      const items = [];
      state.homeBarCategory[cat].forEach((id) => {
        const found = findItemInList(list, id);
        if (found && !seen.has(found.id)) {
          seen.add(found.id);
          items.push(found);
        }
      });
      if (items.length) {
        result.push({ category: cat, items });
      }
    });
    return result;
  },
};

const setMenuList = (state, rootState) => {
  let menu = rootState.menu;
  let _homeBarList = [];
  state.homeBar.map((element) => {
    menu.map((value) => {
      if (element.id === value) {
        if (['2', '5', '18', '27'].includes(value)) {
          console.log(state.hzbjNum, 'state.hzbjNum')
          _homeBarList.push({
            id: "999",
            name: "烟感",
            type: "huozaibaojing",
            num: state.hzbjNum,
            img: require("@/assets/img/top777.png"),
            path: "/listSmokeDangers",
          });
        } else {
          _homeBarList.push(element);
        }
      }
    });
  });
  return Array.from(new Set(_homeBarList.map(JSON.stringify)), JSON.parse);
};

// 在权限过滤后的列表中查找 item，处理烟感报警合并(id 2/5/18/27 -> 999)的特殊情况
const findItemInList = (list, id) => {
  const item = list.find((i) => Number(i.id) === Number(id));
  if (item) return item;
  // 烟感(id=2)、手报(id=5)、光感(id=18)、温感(id=27) 菜单中合并为烟感报警(id=999)
  if ([2, 5, 18, 27].includes(Number(id))) {
    return list.find((i) => Number(i.id) === 999) || null;
  }
  return null;
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/homeBar.js